/** Read-only adapter for the platform-wide GTCC notification summary. */
import { apiGet } from "../../lib/api.js";

export const GTCC_NOTI_PATH = "/v1/admin/gtcc/noti/summary";
export const GTCC_NOTI_KEY = ["gtcc", "noti", "summary"] as const;

export interface GtccPushHealth {
  readonly measuredAt?: string;
  readonly freshnessSeconds?: number;
  readonly deliveries7d: {
    readonly total: number;
    readonly failed: number;
    readonly stuck: number;
  };
  readonly activePushTokens: {
    readonly value: number | null;
    readonly status: "measured" | "not_measured";
    readonly reason?: string;
  };
  readonly deliverableKinds: readonly string[];
  readonly maintenanceDueEnabled: boolean;
}

/** The route exposes read-only cross-tenant aggregates; unavailable measurements stay null. */
export function fetchGtccNoti(signal?: AbortSignal): Promise<GtccPushHealth> {
  return apiGet<GtccPushHealth>(GTCC_NOTI_PATH, undefined, signal);
}
